/* eslint-disable  react/prop-types */

import React from 'react';

const CheckIcon = (props: any) => {
  const { style = {} } = props;

  return (
    <svg
      style={style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_791_50993)">
        <circle cx="8" cy="8" r="7" stroke="#2F9E44" strokeWidth="2" />
        <path
          d="M5 9.09091C5.70294 9.83646 6.8 11 6.8 11L11 6"
          stroke="#2F9E44"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_791_50993">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CheckIcon;
